export class StringUtils {
  static getFirstCharacter(str) {
    if (!str || str.length === 0) {
      return ""; // Return an empty string if str is null or empty
    }
    return str.charAt(0); // Or simply str[0]
  }

  static isStringEmpty(str) {
    if (str == null || str == undefined) {
      return true;
    } else if (str.trim() === "" || str.trim() === " ") {
      return true;
    }
    return false;
  }

  static isEmailValid(email) {
    if (!email)
      return {
        isValid: false,
        message: "Email is required",
      };

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(email);
    return {
      isValid: isValid,
      message: !isValid ? "Enter a valid email address" : "",
    };
  }

  static isPasswordValid(password) {
    if (!password) {
      return {
        isValid: false,
        message: "Password is required",
      };
    } else if (password.length < 8) {
      return {
        isValid: false,
        message: "Password must be at least 8 characters long",
      };
    } else if (!/[A-Z]/.test(password)) {
      return {
        isValid: false,
        message: "Password must contain at least one uppercase letter",
      };
    } else if (!/[0-9]/.test(password)) {
      return {
        isValid: false,
        message: "Password must contain at least one number",
      };
    } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      return {
        isValid: false,
        message: "Password must contain at least one special character",
      };
    } else {
      return {
        isValid: true,
        message: "",
      };
    }
  }

  static generateRandomCharacters() {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 5; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
    return result;
  }

  static capitalizeWords(str) {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }
}
